module.exports = __webpack_public_path__ + "static/media/icon-speaker-off.4c921fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/icon-speaker-off.svg
// module id = 1350
// module chunks = 0